import { render, staticRenderFns } from "./MulticorderUI.vue?vue&type=template&id=66595746&scoped=true&"
import script from "./MulticorderUI.vue?vue&type=script&lang=js&"
export * from "./MulticorderUI.vue?vue&type=script&lang=js&"
import style0 from "./MulticorderUI.vue?vue&type=style&index=0&id=66595746&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66595746",
  null
  
)

export default component.exports